import { marked } from 'marked'
import DOMPurify from 'dompurify'

export function htmlRenderedMarkdown (markdown: string): string {
    const html = marked.parse(markdown)

    // @ts-ignore
    return DOMPurify.sanitize(html)
}
